module.exports = __webpack_public_path__ + "img/image_104.cc5c16f9.png";